import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Product } from '~/Api/Product';
import { cachedFetchItem, selectItemByGroupIdAndId, State as GroupProductState } from '~/GroupProduct';

interface State {
	groupProduct: GroupProductState;
}

interface Props {
	groupId: string;
	id: string;
	product: Product | null;
	children: React.ReactNode;
	onLoad(groupId: string, id: string): void;
}

class ProductProvider extends PureComponent<Props> {
	componentDidMount() {
		const { groupId, id, onLoad } = this.props;
		onLoad(groupId, id);
	}

	render() {
		const { product, children } = this.props;
		return React.cloneElement(children as React.ReactElement, { product });
	}
}

function mapStateToProps(state: State, { groupId, id }: { groupId: string; id: string }): { product: Product | null } {
	const item = selectItemByGroupIdAndId(state.groupProduct, groupId, id);

	return {
		product: item === null ? null : item?.product,
	};
}

const actions: { onLoad: typeof cachedFetchItem } = {
	onLoad: cachedFetchItem,
};

export default connect(mapStateToProps, actions)(ProductProvider);
